<!--
 * @Author: your name
 * @Date: 2021-06-04 16:15:20
 * @LastEditTime: 2021-06-28 15:20:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\contents\tools\feedRecord\milk_volume.vue
-->
<template>
    <div class='container-setting'>
        
        <div class="back" @click.stop="goBack">
            <van-icon name="arrow-left" />
        </div>

        <div class="property-base">
            <span class="text">宝宝月龄</span>
            <div class="baby-month" @click="modifyMonth">

                <div>{{babyMonth}}月</div>

                <van-icon name="arrow" />

            </div>
        </div>

        <van-divider />

        <div class="property-base">
            <span class="text">系统建议奶量</span>
            <div class="baby-month">

                <span>{{adviceMilkAmount.everydayMilkStart}}ml~{{adviceMilkAmount.everydayMilkEnd}}ml</span>
                
            </div>
        </div>


        <van-divider />

        
        <div class="property-base custom-settings">

            <span class="text">设置每日奶量</span>
            <div class="baby-month" @click="modifyMilk">

                <span>{{curMilkAmount.setMilkStart}}ml~{{curMilkAmount.setMilkEnd}}ml</span>

                <van-icon name="arrow" />
                
            </div>
            
        </div>

        <van-divider />


        
        <div class="month-popup">
            <van-popup v-model="showMonthPopup" position="bottom" :style="{ height: '57%' }">
                <div class="month-picker">
                    <van-picker
                        title="月"
                        confirm-button-text=" "
                        cancel-button-text=" "
                        show-toolbar
                        :columns="monthColumns"
                        @change="onChange($event,3)"
                        :default-index="MonthIndex"
                        visible-item-count="4"
                        item-height="48"
                    />
                </div>
                <!-- @change="onChange" -->
                
                <div class="milk-button">
                    <div class="annul" @click="modifyMonth">取消</div>
                    <div class="validation" @click="monthValidation">确认</div>
                </div>
            </van-popup>
        </div>

        <div class="milk-popup">
            <van-popup v-model="showMilkPopup" position="bottom" :style="{ height: '45%' }">
                <div class="milk-picker">
                    <van-picker
                        title="最小值"
                        confirm-button-text=" "
                        cancel-button-text=" "
                        show-toolbar
                        :columns="milkMinimalColumns"
                        @change="onChange($event,1)"
                        :default-index="curMilkAmount.minIndex"
                        visible-item-count="3"
                        item-height="48"
                    />
                    <van-picker
                        title="最大值"
                        confirm-button-text=" "
                        cancel-button-text=" "
                        show-toolbar
                        :columns="milkMaximumColumns"
                        @change="onChange($event,2)"
                        :default-index="curMilkAmount.maxIndex"
                        visible-item-count="3"
                        item-height="48"
                    />
                </div>


                <van-divider
                    class="title-divider"
                    :style="{ borderColor: '#E5E5E5', padding: '0 12px' }"
                />
                <van-divider
                    class="column-top"
                    :style="{ borderColor: '#E5E5E5' }"
                />
                <van-divider
                    class="column-bottom"
                    :style="{ borderColor: '#E5E5E5' }"
                />

                <div class="milk-button">
                    <div class="annul" @click="modifyMilk">取消</div>
                    <div class="validation" @click="milkValidation">确认</div>
                </div>
            </van-popup>
            
            
        </div>


        <div class="page-submit">
            <div class="reset" @click="resetDailyMilk">重置</div>
            <div class="save" @click="pageSubmit">保存</div>
        </div>



        <!-- <div class="popup">
            <van-popup v-model="showPopup" position="bottom" :style="{ height: '37%' }">
                <van-datetime-picker v-model="currentDate" type="date" title="" confirm-button-text="确认" cancel-button-text="取消" visible-item-count="4" :min-date="minDate" :max-date="maxDate" @confirm="confirm" @cancel="cancel" />
            </van-popup>
        </div> -->

        
    </div>
</template>

<script>
import { Exposurer_feedToolsAllpageView } from '@/assets/js/Exposure';
import { refPowder, referMilk, customMilk } from '@/utils/mockData/referMilkData'
export default {
    name:"milkVolume",
    data() {
        return {
            UserInfo: JSON.parse(localStorage.getItem('userInfo')) || null,// 用户信息
            babyMonth: '1',
            // minimalMilk: '300ml',
            // maximumMilk: '400ml',
            showMonthPopup: false,// 月份弹窗标识
            showMilkPopup: false,// 奶量弹窗标识
            currentDate: null,
            MonthIndex: 2,// 月份默认索引
            monthColumns: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12','13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25','26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36'],
            adviceMilkAmount: {// 系统默认值,根据产品文档查询
                everydayMilkStart: '400ml',
                everydayMilkEnd: '500ml',
            },
            curMilkAmount: {// 当前设置范围
                setMilkStart: '300',
                setMilkEnd: '400',
                minIndex: 1,
                maxIndex: 1,
            },
            milkMinimalColumns: ['200ml','300ml','400ml'],// 最小值
            milkMaximumColumns: ['300ml','400ml','500ml'],// 最大值
            monthAmount: 1,// 
            milkAmount: {// picker选择的参数
                minimalm: null,
                maximum: null
            },
            setFeedId: null,// 掉接口时查询的id
        }
    },
    mounted() {
        
        this.milkMinimalColumns=customMilk.minimum
        this.milkMaximumColumns=customMilk.maximum

        
        // 设置系统建议量
        this.setAdviceMilkAmount(this.$route.query.feedType)

        // this.resetDailyMilk(this.$route.query.feedType)
        // 设置用户自定义值
        this.setMilkIndex(this.adviceMilkAmount.everydayMilkStart,this.adviceMilkAmount.everydayMilkEnd)// 用户奶量(设置索引及当前选择范围)
        


        // month index init
        this.monthColumns.forEach((ele, idx, arr)=>{
            if(arr[idx]==this.babyMonth){
                this.MonthIndex = idx
            }
        })
        // The custom index init
        this.milkAmount.minimalm = this.milkMinimalColumns[this.curMilkAmount.minIndex].slice(0,this.milkMinimalColumns[this.curMilkAmount.minIndex].length - 2)
        this.milkAmount.maximum = this.milkMaximumColumns[this.curMilkAmount.maxIndex].slice(0,this.milkMaximumColumns[this.curMilkAmount.maxIndex].length - 2)


        //浏览页面埋点
        setTimeout(() => {
          const data = JSON.parse(localStorage.getItem("toolFeedPoint"));
          Exposurer_feedToolsAllpageView.observe('.container-setting', false,  {
            System_FeedingCapacity: data.System_FeedingCapacity,
            Baby_Month: data.Baby_Month,
            Feeding_way_Home: data.Feeding_way_Home,
            page_name: '奶量设置'
          })
        }, 2000)
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        // 设置系统建议奶量
        setAdviceMilkAmount(feedType) {
            // picker默认索引有问题
            if (feedType == 1) {
                this.adviceMilkAmount.everydayMilkStart=refPowder[this.babyMonth].minimum
                this.adviceMilkAmount.everydayMilkEnd=refPowder[this.babyMonth].maximum
            } else {
                this.adviceMilkAmount.everydayMilkStart=referMilk[this.babyMonth].minimum
                this.adviceMilkAmount.everydayMilkEnd=referMilk[this.babyMonth].maximum
            }
        },
        /**
         * 设置当前展示索引,用户可修改默认奶量的默认值
         */
        setMilkIndex(curMinimalm,curMaximum) {
            console.log(this.milkMinimalColumns,curMinimalm);
            this.milkMinimalColumns.forEach((ele, idx, arr)=>{
                if (arr[idx].slice(0,arr[idx].length -2) == curMinimalm) {
                    this.curMilkAmount.minIndex = idx;
                    
                }
            })

            
            this.milkMaximumColumns.forEach((ele, idx, arr)=>{
                if (arr[idx].slice(0,arr[idx].length -2) == curMaximum) {
                    this.curMilkAmount.maxIndex = idx;
                    
                }
            })

            
            this.curMilkAmount.setMilkStart = curMinimalm
            this.curMilkAmount.setMilkEnd = curMaximum
        },
        resetDailyMilk(type) {
            
            var curMinimalm = this.curMilkAmount.setMilkStart,
                curMaximum = this.curMilkAmount.setMilkEnd;

                
            // this.babyMonth = this.$route.query.monthAge

            
            // this.adviceMilkAmount=referMilk[babyMonth].minimum
            // this.adviceMilkAmount.everydayMilkEnd=referMilk[babyMonth].maximum

            // if (type == 1) {
            //     // 设置每日建议量(奶粉)
            //     this.adviceMilkAmount.everydayMilkStart
            //     this.adviceMilkAmount.everydayMilkEnd
            // } else {
            //     // 设置每日建议量(母乳)
            //     this.adviceMilkAmount.everydayMilkStart
            //     this.adviceMilkAmount.everydayMilkEnd
            // }



            // 好像没必要查索引,根据地址参数确定月龄,根据月龄查询的系统默认参数(这个函数会在初始化与重置中使用)|确定索引的价值在于重置弹窗默认值,可在弹窗时设置
            this.setMilkIndex(this.adviceMilkAmount.everydayMilkStart,this.adviceMilkAmount.everydayMilkEnd)// 用户奶量(设置索引及当前选择范围)



            this.milkAmount.minimalm=this.curMilkAmount.setMilkStart

            this.milkAmount.maximum=this.curMilkAmount.setMilkEnd


        },
        modifyMonth() {
            this.showMonthPopup=!this.showMonthPopup
        },
        modifyMilk() {
            this.showMilkPopup = !this.showMilkPopup
        },
        onChange(e,num) {
            
            console.log(e.getValues(e.$el)[0]);
            var value = e.getValues(e.$el)[0]

            if (num == 1) {
                console.log(value);
                this.milkAmount.minimalm = value.slice(0,e.getValues(e.$el)[0].length - 2)
            } else if (num == 2) {
                console.log(value);
                this.milkAmount.maximum = value.slice(0,e.getValues(e.$el)[0].length - 2)

            } else {
                console.log(value);
                this.monthAmount = value
            }
            
            
        },
        // 确认月份
        monthValidation() {
            var monthAmount = this.monthAmount
            if (this.babyMonth != monthAmount) {
                this.babyMonth = monthAmount
                if (this.babyMonth == this.$route.query.monthAge) {
                    
                    this.getRecommendedMilk()
                }

                if (this.$route.query.feedType == 1) {
                    this.adviceMilkAmount.everydayMilkStart=refPowder[monthAmount]&&refPowder[monthAmount].minimum
                    this.adviceMilkAmount.everydayMilkEnd=refPowder[monthAmount]&&refPowder[monthAmount].maximum
                } else {
                    this.adviceMilkAmount.everydayMilkStart=referMilk[monthAmount]&&referMilk[monthAmount].minimum
                    this.adviceMilkAmount.everydayMilkEnd=referMilk[monthAmount]&&referMilk[monthAmount].maximum
                }
                
                // if (this.$route.query.feedType == 1) {
                //     this.adviceMilkAmount.everydayMilkStart=refPowder[monthAmount]&&refPowder[monthAmount].minimum
                //     this.adviceMilkAmount.everydayMilkEnd=refPowder[monthAmount]&&refPowder[monthAmount].maximum
                // } else {
                //     this.adviceMilkAmount.everydayMilkStart=referMilk[monthAmount]&&referMilk[monthAmount].minimum
                //     this.adviceMilkAmount.everydayMilkEnd=referMilk[monthAmount]&&referMilk[monthAmount].maximum
                // }

                // this.setAdviceMilkAmount(this.$route.query.feedType)

                this.modifyMonth()
            }
            
        },
        // 用户设置最小、最大值后确认
        milkValidation() {
            var minimalm = this.milkAmount.minimalm,
                maximum  = this.milkAmount.maximum;
            var curMinimalm = this.curMilkAmount.setMilkStart,
                curMaximum = this.curMilkAmount.setMilkEnd;
            // console.log(minimalm.substr(0,minimalm.length-2));
            // if (!minimalm || !maximum || !curMinimalm || !curMaximum ) {
            //     return
            // }
            
            if (curMinimalm!=minimalm || curMaximum!=maximum) {
                console.log(parseFloat(minimalm),parseFloat(maximum));


                if (parseFloat(minimalm) >= parseFloat(maximum)) {
                    this.$toast('当日建议奶量的最高值不能低于最低值')
                } else {
                    
                    // this.curMilkAmount.setMilkStart = minimalm
                    // this.curMilkAmount.setMilkEnd = maximum

                    this.setMilkIndex(minimalm,maximum)

                    // this.curMilkAmount.setMilkStart = this.milkAmount.minimalm
                    // this.curMilkAmount.setMilkEnd = this.milkAmount.maximum
                    
                    this.modifyMilk()
                    
    
                }

                
            }

            
        },
        getRecommendedMilk() {
            var crmId = this.UserInfo.crm_id
            var babyMoonAge = parseInt(this.$route.query.monthAge)
            console.log(babyMoonAge,'月龄');
            var parity = 1// 胎次
            var feedType = this.$route.query.feedType;
            
            return new Promise(reslove=>{
                this.$http.post('/milkSet/recommendedMilk',{},{crmId,feedType,parity,babyMoonAge},res=>{
                    if (res.code == 200 && res.data) {
                        // this.curMilkAmount.minimalm = res.data.setMilkStart
                        // this.curMilkAmount.maximum = res.data.setMilkEnd

                        
                        this.setMilkIndex(res.data.setMilkStart,res.data.setMilkEnd)

                        this.setFeedId = res.data.id
                        
                        reslove(res.data)
                    }
                    // reslove(res.data)
                })
            })
        },
        pageSubmit() {
            var that = this
            // 调用接口提交后台,跳转到主页,默认食量更新
            var crmId = this.UserInfo.crm_id
            var id = this.$route.query.setFeedId || undefined// 新添加不需要
            var parity = this.$route.query.num
            var feedType = this.$route.query.feedType// 1为奶粉2为母乳
            var babyMoonAge = this.babyMonth
            var everydayMilkStart = this.adviceMilkAmount.everydayMilkStart
            var everydayMilkEnd = this.adviceMilkAmount.everydayMilkEnd
            var setMilkStart = this.curMilkAmount.setMilkStart
            var setMilkEnd = this.curMilkAmount.setMilkEnd
            var isDel = false
            
            // The trigger: 点击奶量设置保存
            sensors.track('Tool_Feedinglog_Setting_Save_Click', {
                Feeding_way_Home: feedType == 1? '奶粉喂养': '母乳喂养',
                Baby_Month: that.$route.query.monthAge,
                Setting_FeedingCapacity_Month: babyMoonAge,
                Setting_FeedingCapacity_Mini: setMilkStart,
                Setting_FeedingCapacity_Max: setMilkEnd,
            })

            // 存在id
            if (id) {
                if (babyMoonAge == this.$route.query.monthAge) {
                    this.$http.post('/milkSet/saveMilkSet',{},
                    {id, crmId,parity,feedType,babyMoonAge,everydayMilkStart,everydayMilkEnd,setMilkStart,setMilkEnd,isDel},
                    res=>{
                        console.log(res);
                        this.$router.go(-1)
                    })
                } else {
                    this.$http.post('/milkSet/saveMilkSet',{},
                    {crmId,parity,feedType,babyMoonAge,everydayMilkStart,everydayMilkEnd,setMilkStart,setMilkEnd,isDel},
                    res=>{
                        console.log(res);
                        this.$router.go(-1)
                    })
                }
            } else {
                this.$http.post('/milkSet/saveMilkSet',{},
                {crmId,parity,feedType,babyMoonAge,everydayMilkStart,everydayMilkEnd,setMilkStart,setMilkEnd,isDel},
                res=>{
                    console.log(res);
                    this.$router.go(-1)
                })
            }
            // this.$nextTick(() => {
            //     this.$router.go(-1)
            // })
        },
    },
}
</script>

<style scoped lang='less'>
.container-setting {
    height: 100%;
    background: #fff;
    padding: 0 12px;
    padding-top: 35px;
    box-sizing: border-box;
    .back {
        width: 10px;
        height: 20px;
        position: absolute;
        top: 15px;
        left: 13px;
        .van-icon-arrow-left {
        position: absolute;
        left: -5px;
        color: #1a1a1a;
        font-size: 20px;
        }
    }
}
.property-base {
    color: #333;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 50px;
}

.baby-month {
    display: flex;
    align-items: center;
}

.text {
    color: #666;
}

// .moon-age {
//     display: flex;
//     justify-content: space-between;
//     font-size: 14px;
//     padding-top: 20px;
//     padding-bottom: 7px;
// }

// .system-advice {
//     display: flex;
//     justify-content: space-between;
//     font-size: 14px;
//     padding-top: 20px;
//     padding-bottom: 7px;
// }

// .custom-settings {
    
    
// }

.month-popup {
    
    .month-picker {











        /deep/ .van-picker__columns {
            margin-top: 11px;
            
        }

        // /deep/ .van-picker-column {
        //     height: 192px;
        // }
        
    }
}

.milk-popup {
    position: relative;
    
    .milk-picker {
        display: flex;
        justify-content: space-around;

        
        /deep/ .van-picker__title {
            font-size: 15px;
        }

        /deep/ .van-picker__toolbar {
            height: 45px;
        }
        
        /deep/ .van-picker__columns {
            margin-top: 11px;
            
        }
        
        /deep/ .van-picker__title {
            // font-size: 15px;
            color: #DFB162;
        }

        /deep/ .van-hairline--top-bottom::after, /deep/ .van-hairline-unset--top-bottom::after {
            // border-width: 0.5px;
            border:none
        }
        
    }

    .title-divider {
        position: absolute;
        top: 45px;
        left: 0;
        right: 0;
    }

    .column-top {
        position: absolute;
        top: 102px;
        left: 0;
        right: 0;
    }

    .column-bottom {
        position: absolute;
        top: 148px;
        left: 0;
        right: 0;
    }

    


}


.milk-button {
    // position: absolute;
    // bottom: 0;
    display: flex;
    justify-content: space-between;
    padding: 0 72px;
    margin-top: 27px;
    >div {
        width: 109px;
        height: 36px;
        border-radius: 4px;
        background: pink;
        text-align: center;
        line-height: 38px;
        font-size: 17px;
    }
    .annul {
        color: #DFB162;
        background: #f2f2f2;
    }
    .validation {
        color: #fff;
        background: #DFB162;
    }
}















.page-submit {
    display: flex;
    height: 58px;
    font-size: 14px;
    padding: 0 12px;
    box-shadow: 0 0 8px -1px #f2f2f2;
    position: fixed;
    justify-content: space-between;
    align-items: center;
    left: 0;
    right: 0;
    bottom: 0;
    .reset {
        color: #333333;
        width: 110px;
        height: 34px;
        border-radius: 24.5px;
        border: 1px solid #E9E9E9;
        text-align: center;
        line-height: 35px;
    }
    .save {
        color: #FFFFFF;
        width: 230px;
        height: 34px;
        border-radius: 24.5px;
        background: linear-gradient(to left, #D4A437,#E5BF5D);
        text-align: center;
        line-height: 35px;
    }
}



/deep/ .van-divider {
    margin: 0;
}


</style>